/* @flow */

import actionTypes from './types';

const {
  SET_THEME,
} = actionTypes;

// eslint-disable-next-line import/prefer-default-export
export const setTheme = (theme: string) => (dispatch: Function) => dispatch({
  type: SET_THEME, data: theme,
});
